module.exports = __webpack_public_path__ + "img/bg-line-1-desktop.8030b6c1.png";